const initialState = {
  cuisines: [],
  loading: false,
};

function cuisineReducer(state = initialState, action) {
  switch (action.type) {
    case 'GET_ALL_CUISINE': {
      return { ...state, cuisines: action.payload };
    }

    default: {
      return state;
    }
  }
}

export default cuisineReducer;
